







































import { Component } from 'vue-property-decorator';
import Mixin from '@/mixin';
import coachService from '@/services/common/coach.service';
import authModule from '@/store/modules/common/auth.module';
import { Coach } from '@/store/models';
import messageModule from '@/store/modules/common/message.module';
import { MessageType } from '@/config/enum';

@Component({
  name: 'ReportForm'
})
export default class ReportForm extends Mixin {
  public coaches: Coach[] = [];

  async save() {
    const data = this.coaches.map(c => {
      return {
        id: c?.id || -1,
        department: c?.department || '',
        jobTitle: c?.jobTitle || '',
      };
    });
    await coachService.updateCoachDepartment(
      data as { id: number; department: string }[]
    );
    await messageModule.showMessage({
      message: 'Your change has been updated!',
      type: MessageType.info
    });
  }

  mounted() {
    coachService
      .loadCoachByCompany({
        companyName: authModule.user?.companyName || ''
      })
      .then(data => {
        this.coaches = [...data];
      });
  }

  public setDepartmentFocus(id: number | null) {
    if (!id) return;
    this.$refs[('department' + id)]?.[0]?.focus();
  }

  public setJobFocus(id: number | null) {
    if (!id) return;
    this.$refs[('job' + id)]?.[0]?.focus();
  }
}
